import { ReactNode } from 'react';

import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import {
  RegisterBanner,
  RegisterContainer,
} from '@pages/common/Register/StyledComponents';

import backgroundImage from '@assets/register-bg.jpeg';
import synapseLogo from '@assets/synapse-logo.png';
import ThemeModeToggle from '@components/ThemeModeToggle';

interface IRegisterContainerProps {
  children: ReactNode;
}
const RegisterColumnView = ({ children }: IRegisterContainerProps) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <RegisterContainer sx={{ position: 'relative' }}>
      <Box sx={{ position: 'fixed', top: 16, right: 16, zIndex: 1 }}>
        <ThemeModeToggle />
      </Box>
      <Grid container>
        <Grid item xs={12} sm={12} md={5}>
          {children}
        </Grid>
        {!isSmall && (
          <Grid item md={7} xs={0}>
            <RegisterBanner
              sx={{ backgroundImage: `url("${backgroundImage}")` }}
            >
              <img src={synapseLogo} className="logo" alt="synapse logo" />
            </RegisterBanner>
          </Grid>
        )}
      </Grid>
    </RegisterContainer>
  );
};

export default RegisterColumnView;
